import { forwardRef, useEffect, useMemo, useRef } from "react";
import { useFormContext, Controller } from "react-hook-form";
import { useParams } from "react-router-dom";
import { MDBRow, MDBCol } from "mdbreact";

import "./FeuD4SailingInIce.scss";

import { Button, Label, TextArea } from "abs-ui-components";

import { FuelEuDCommonTableColumns } from "../../FeuConstants";
import { callApi } from "../../../../../services/MonitoringPlanService";
import { emitToasterMsg } from "../../../../../services/toasterUtility";
import { API_ROUTES } from "../../FeuApiRoutes/FeuApiRoutes";
import AutoSave from "../../../../../common/AutoSave/AutoSave";
import { AUTOSAVE_SUCCESS_MESSAGE } from "../../../Mrv/Constants";

const FeuD4SailingInIce = forwardRef(({ D4FeuSailingInIceData, refetchMonitoringData,vesselMstId}, ref) => {
    const { control, getValues, reset, formState } = useFormContext();
    const { isDirty } = formState;
    const lastManualSave = useRef(null);
    const manualSaveTriggered = useRef(false);

    useEffect(() => {
        if (D4FeuSailingInIceData) {
            reset(prev => ({ ...prev, d4: D4FeuSailingInIceData }));
        }
    }, [D4FeuSailingInIceData, reset]);

    AutoSave(ref, [], async () => {
        if (!isDirty) return;
        await handleSave(true);
    });

    const handleSave = async (isAuto = false) => {
        const formValues = getValues("d4");
        const payload = d4FeuFields.reduce((acc, { name }) => {
            acc[name] = formValues?.[name] ?? "";
            return acc;
        }, {});
        try {
            const FeuD4SailingInIce = await callApi({
                method: "POST",
                url: API_ROUTES.D4(vesselMstId),
                data: payload,
            });
            if (FeuD4SailingInIce?.isSuccess) {
                emitToasterMsg("success", "Table D.4", isAuto ? AUTOSAVE_SUCCESS_MESSAGE : "Created successfully");
                reset(prev => ({ ...prev, d4: formValues }));
                if (!isAuto) {
                    lastManualSave.current = Date.now();
                }
                if (typeof refetchMonitoringData === "function") {
                    await refetchMonitoringData();
                }
            }
            else {
                emitToasterMsg("error", "Table D.4", FeuD4SailingInIce?.errorMessage);
            }
        } catch (error) {
            emitToasterMsg("error", "Table D.4", error?.errorMessage);
        }
    };

    const d4FeuFields = useMemo(() => {
        const base = FuelEuDCommonTableColumns.filter(
            f => f.name !== "backupMonitoringMethod" && f.name !== "methodDescription"
        );
        base.splice(1, 0, {
            label: "Description of method to treat data gaps",
            name: "methodDescription",
            maxLength: 4000,
        });
        return base;
    }, []);

    return (
        <div className="d4-section-form mt-4">
            <MDBRow className="mb-2">
                <MDBCol md="4">
                    <h6 className="titles-font">Title of method</h6>
                </MDBCol>
                <MDBCol md="8">
                    <h6 className="titles-font">
                        Method to treat data gaps regarding the date, time and position when entering and leaving the ice conditions, the distance travelled when sailing in ice conditions
                    </h6>
                </MDBCol>
            </MDBRow>

            {d4FeuFields.map(({ label, name, maxLength, type }, index) => (
                <MDBRow className="align-items-center mb-3" key={index}>
                    <MDBCol md="4">
                        <Label name={label} bold />
                    </MDBCol>
                    <MDBCol md="4">
                        <Controller
                            name={`d4.${name}`}
                            control={control}
                            render={({ field }) => (
                                <TextArea
                                    id={`d4_${name}`}
                                    className="textarea-resize"
                                    value={field.value || ""}
                                    onChange={field.onChange}
                                    placeholder=""
                                    maxLength={maxLength}
                                    rows={1}
                                />
                            )}
                        />
                    </MDBCol>
                </MDBRow>
            ))}
            <div className="text-center">
                <Button id="feud4_save_btn"
                    disabled={!isDirty}
                    onClick={async () => {
                        manualSaveTriggered.current = true;
                        await handleSave(false);
                    }}>
                    Save
                </Button>
            </div>
        </div>
    );
});

export default FeuD4SailingInIce;
